/** ユーザーがアニメーションの抑制を希望しているか */
export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * jQuery の slideDown / slideUp 相当を Web Animations API で実装する。
 * @param {HTMLElement} element
 * @param {boolean} open 開くなら true
 * @param {number} duration ミリ秒
 * @returns {Promise<void>}
 */
export const slideToggle = async (element, open, duration = 300) => {
  element.style.overflow = 'hidden';

  if (open) {
    element.hidden = false;
    element.style.removeProperty('display');
  }

  const { height } = element.getBoundingClientRect();
  const frames = open
    ? [{ height: '0px' }, { height: `${height}px` }]
    : [{ height: `${height}px` }, { height: '0px' }];

  if (!prefersReducedMotion()) {
    await element.animate(frames, { duration, easing: 'ease-in-out' }).finished;
  }

  element.style.removeProperty('overflow');
  element.hidden = !open;
};
